import { IUseWeatherDataParser } from '@/interfaces/IUseWeatherDataParser';

enum Direction {
  N = "N",
  NE = "NE",
  E = "E",
  SE = "SE",
  S = "S",
  SW = "SW",
  W = "W",
  NW = "NW",
}

const angleToDirection = (angle: number): Direction => {
  // Normalize the angle to the range [0, 360)
  angle = (angle % 360 + 360) % 360;

  // List of direction abbreviations
  const directions: Direction[] = [
    Direction.N,
    Direction.NE,
    Direction.E,
    Direction.SE,
    Direction.S,
    Direction.SW,
    Direction.W,
    Direction.NW,
  ];

  // Calculate the index for the direction
  const index: number = Math.round(angle / 45) % 8;

  return directions[index];
}

export default (): IUseWeatherDataParser => {
  const direction = (degrees: number): string => angleToDirection(degrees);

  const directionToIconMapper = (directionCode: string): string => {
    switch (directionCode) {
      case 'N':
        return 'icomoon-meteo-direction-s';
      case 'NE':
        return 'icomoon-meteo-direction-sw';
      case 'E':
        return 'icomoon-meteo-direction-w';
      case 'SE':
        return 'icomoon-meteo-direction-nw';
      case 'S':
        return 'icomoon-meteo-direction-n';
      case 'SW':
        return 'icomoon-meteo-direction-ne';
      case 'W':
        return 'icomoon-meteo-direction-e';
      case 'NW':
        return 'icomoon-meteo-direction-se';
      default:
        return '';
    }
  };

  return {
    direction,
    directionToIconMapper,
  };
};
